import ShareableDialog from './ShareableDialog';

export default ShareableDialog;
